module.exports = __webpack_public_path__ + "img/PODRAN.fcb3e667.png";